import { Controller } from "@hotwired/stimulus"

// The zone select on the account page, with the browser's own answer one
// press away. A list of four hundred zones is the honest control — a keeper
// who has moved knows where to — but most corrections are "the device knows
// better than my signup did", so the button appears only when the device's
// zone is in the list and differs from the one chosen.
export default class extends Controller {
  static targets = ["select", "detect"]

  connect() {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!zone || !this.hasSelectTarget) return

    this.zone = zone
    const known = Array.from(this.selectTarget.options).some((option) => option.value === zone)
    if (known && this.selectTarget.value !== zone && this.hasDetectTarget) {
      this.detectTarget.textContent = `Use this device's zone (${zone})`
      this.detectTarget.hidden = false
    }
  }

  detect() {
    if (!this.zone) return
    this.selectTarget.value = this.zone
    if (this.hasDetectTarget) this.detectTarget.hidden = true
  }
}
